import { ReactComponent as AccountStoreType } from './account-store-type.svg'
export default AccountStoreType
